export const scrollToFirstError = () => {
  if (document.querySelector('.js-common-error')) {
    document.querySelector('.js-common-error')!.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
};
